'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _HolderOutlined = _interopRequireDefault(require('./lib/icons/HolderOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _HolderOutlined;
  exports.default = _default;
  module.exports = _default;